// Recorte BRL | Global das telas do admin. BRL = PIX em reais; Global = tudo que não é PIX BRL
// (voucher LATAM em MXN, COP, CLP... e o saque internacional em USDT). Cada tela mostra uma
// região por vez, escolhida na aba do topo e guardada em `?region=` (omitido em `brl`, o
// default), no mesmo molde do `status` de `routes/admin.kyc.tsx`.

import { z } from 'zod';
import { Segmented } from '../../components/kit/segmented.tsx';

export const ADMIN_REGIONS = ['brl', 'global'] as const;
export type AdminRegion = (typeof ADMIN_REGIONS)[number];

export const DEFAULT_REGION: AdminRegion = 'brl';

/**
 * Campo de `search` para as rotas. Opcional de propósito (mesma razão de
 * `validateAdminOverviewSearch`): `region` obrigatório tornaria `search` obrigatório em todo
 * `<Link to="/admin/...">` do painel. Lixo na URL cai em `undefined`, que é `brl`.
 */
export const regionSearchField = z.enum(ADMIN_REGIONS).optional().catch(undefined);

export function regionOf(value: AdminRegion | undefined): AdminRegion {
  return value ?? DEFAULT_REGION;
}

/** O que entra na URL: `brl` é o default e não aparece. */
export function regionSearchOf(region: AdminRegion): { region?: AdminRegion } {
  return region === DEFAULT_REGION ? {} : { region };
}

export function isAdminRegion(value: string): value is AdminRegion {
  return ADMIN_REGIONS.some((region) => region === value);
}

export const REGION_LABEL: Record<AdminRegion, string> = { brl: 'BRL', global: 'Global' };

const ITEMS = ADMIN_REGIONS.map((region) => ({ id: region, label: REGION_LABEL[region] }));

/** Aba BRL | Global do cabeçalho de cada tela. */
export function RegionTabs({
  value,
  onChange,
}: {
  value: AdminRegion;
  onChange: (next: AdminRegion) => void;
}) {
  return (
    <Segmented
      label="Região"
      items={ITEMS}
      value={value}
      onChange={(id) => {
        if (isAdminRegion(id)) {
          onChange(id);
        }
      }}
    />
  );
}
